export const spaceID = "a826mlmnqk6u";
export const contentAPI = "VrTbZh_fquM24pGoCpsjFXqo74R8MPiGL516ZlZIY-E";
export const previewAPI = "FqO3DLIA27dTC9lXnl2NG2-Z5SqlruVPkxwLgIuN_Vg";

export const content = {
  homepageContentId: "6ZUMxdMv9ZJYPl43IXfFee",
};